  <template>
  <div class="app-container">
    <div class="btn">
      <el-button type="primary"
                 @click="addSync">添加同步器</el-button>
    </div>
    <el-table class="sync-table"
              :data="syncList"
              border>
      <el-table-column label="ID"
                       width="100%">
        <template slot-scope="scope">
          <span>{{scope.row._id}}</span>
        </template>
      </el-table-column>
      <el-table-column label="名称"
                       width="100%">
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column label="源路径">
        <template slot-scope="scope">
          <span>{{scope.row.sourcePath}}</span>
        </template>
      </el-table-column>
      <el-table-column label="目标路径">
        <template slot-scope="scope">
          <span>{{scope.row.rsyncUrl}}</span>
        </template>
      </el-table-column>
      <el-table-column label="立即同步"
                       width="100%">
        <template slot-scope="scope">
          <span v-if="scope.row.isImmediately">
            <font color="green">是</font>
          </span>
          <span v-else>
            <font color="red">否</font>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="监控模式"
                       width="100%">
        <template slot-scope="scope">
          <span v-if="scope.row.isWatching">
            <font color="green">是</font>
          </span>
          <span v-else>
            <font color="red">否</font>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button v-if="scope.row.isWatching"
                     type="danger"
                     size="mini">禁用监控</el-button>
          <el-button v-else
                     type="success"
                     size="mini">启用监控</el-button>
          <el-button type="primary"
                     size="mini"
                     @click="startSync(scope.row._id)">同步</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import api from '../api/api'
  ;

export default {
  name: 'sync-config',
  mounted() {
    this.getSyncList();
  },
  data() {
    return {
      //       // 同步器ID
      // _id: '123456',
      // // 同步器名称
      // name: '测试同步器',
      // // 监控路径
      // sourcePath: '/home/gsgtzq/watch_path/*',
      // // rsync的地址
      // rsyncUrl: 'rsync://sync@localhost/sync-data',
      // // rsync的密码
      // rsyncPassword: '123456',
      // // 是否为立即同步模式，如果为立即同步模式，则会当监控路径发生变化时，立刻执行rsync
      // isImmediately: true,
      // // 是否监控sourcePath的文件变化
      // isWatching: true,
      // syncList: [{
      //   _id: '123',
      //   name: '测试同步器',
      //   sourcePath: '/home/gsgtzq/watch_path/*',
      //   rsyncUrl: 'rsync://sync@localhost/sync-data',
      //   isImmediately: true,
      //   isWatching: false,
      // }],
      syncList: [],
    };
  },
  methods: {
    getSyncList() {
      this.$http.get(`${api.url}syncList`).then((resp) => {
        this.syncList = resp.data.content;
      });
    },
    addSync() {
      this.$router.push('/system/sync-add');
    },
    startSync(id) {
      this.$http.post(`${api.url}syncStart`, { id }).then((resp) => {
        if (resp.data.ret === 0) {
          this.$message({
            type: 'success',
            message: resp.data.msg,
          });
        }
      });
    },
    changeWatch() {
      // 改变监控状态
    },
  },
};
</script>

<style>
.sync-table {
  margin-top: 20px;
}
.btn {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/SyncConfig.vue